import React from 'react';
import { InputNumber, InputNumberProps } from 'antd';
import styled from 'styled-components';

const CustomInput = styled(InputNumber)`
  width: 100%
`;

const InputNumberFull: React.FC<InputNumberProps> = ({...rest}) => {
  return (
    <CustomInput {...rest} ></CustomInput>
  );
};

export default InputNumberFull;